<template lang="pug">
.controls
  .search-filters-summary(v-if="appliedFilterSummaries.length")
    aiq-tag.filter-summary-tag(v-for="summary in appliedFilterSummaries"
                               :key="summary.key"
                               closable
                               close-transition
                               @close="removeFilterSummary(summary)")
      | {{ summary.label }}
  aiq-button.clear-filters(v-if="appliedFilterSummaries.length" link @click.stop="clearFilter") Clear all
  .right-controls
    aiq-button.filter-selectors-btn(plain @click="openFiltersForm()")
      font-awesome-icon(icon="filter")
      span.label Search & filter
      span.filters-count ({{ activeFiltersCount }})
    .totals {{ totalResults }} results
.filters-form(v-if="showFiltersForm")
  .form-header
    .form-header-title
      | Search and filter
    .form-header-close
      fa-icon(:icon="['fas', 'xmark']" @click="closeFiltersForm()")
  .form-body
    .form-fields
      .filter-field
        label.filter-field-label Search
        template(v-if="customerProfileOptionsList.length > 1")
          aiq-select(placeholder="All"
                    v-model="filters.customerProfileOption"
                    :suffix-icon="Icon.ArrowDown"
                    popper-class="customer-table-controls-select-popper"
                    value-key="field"
                    size="small")
            aiq-option(v-for="option in customerProfileOptionsList"
                      :key="option.field"
                      :label="option.label"
                      :value="option")
          aiq-input.search-input(size="small"
                    v-model="filters.query"
                    placeholder="Search"
                    clearable)
        aiq-input.search-input(v-else
                  size="small"
                  v-model="filters.query"
                  placeholder="Search"
                  clearable)
      .filter-field
        label.filter-field-label Segments
        collapsible-select(placeholder="Segments"
                    v-model="filters.customerSegmentOption"
                    :value="filters.customerSegmentOption"
                    size="small"
                    popper-class="customer-table-controls-select-popper"
                    :suffix-icon="Icon.ArrowDown"
                    multiple
                    :reserve-keyword="false"
                    clearable)
          aiq-option(v-for="option in customerSegmentOptions"
                    :key="option"
                    :label="option"
                    :value="option")
      .filter-field
        label.filter-field-label Tags
        aiq-select(placeholder="Tags"
                  size="small"
                  clearable
                  multiple
                  popper-class="customer-table-controls-select-popper"
                  :suffix-icon="Icon.ArrowDown"
                  v-model="filters.customerTagOption")
          aiq-option(v-for="option in customerTagOptions"
                    :key="option"
                    :label="option"
                    :value="option")
      .filter-field(v-if="showChannelFilter")
        label.filter-field-label Channel
        aiq-select(placeholder="Channel"
                  size="small"
                  popper-class="customer-table-controls-select-popper"
                  :suffix-icon="Icon.ArrowDown"
                  v-model="filters.customerChannelOption"
                  clearable)
          aiq-option(v-for="option in customerChannelOptions"
                    :key="option"
                    :label="option"
                    :value="option")
      .filter-field
        label.filter-field-label Teams
        collapsible-select(placeholder="Teams"
                    v-model="filters.customerTeamOption"
                    :value="filters.customerTeamOption"
                    size="small"
                    popper-class="customer-table-controls-select-popper"
                    :suffix-icon="Icon.ArrowDown"
                    multiple
                    :reserve-keyword="false"
                    clearable)
          aiq-option(v-for="team in teamFilterOptions"
                    :key="team.id"
                    :label="team.name"
                    :value="String(team.id)")
      .filter-field(v-if="showAssignedAgentsFilter")
        label.filter-field-label Assigned agents
        collapsible-select(placeholder="Assigned agents"
                    v-model="filters.agentFilterOption"
                    :value="filters.agentFilterOption"
                    size="small"
                    popper-class="customer-table-controls-select-popper"
                    :suffix-icon="Icon.ArrowDown"
                    multiple
                    :reserve-keyword="false"
                    clearable)
          aiq-option(v-for="agent in agentFilterOptions"
                    :key="agent.id"
                    :label="agent.fullName"
                    :value="String(agent.id)")
      .filter-field(v-if="showPrimaryAgentsFilter")
        label.filter-field-label Primary agents
        collapsible-select(placeholder="Primary agents"
                    v-model="filters.primaryAgentFilterOption"
                    :value="filters.primaryAgentFilterOption"
                    size="small"
                    popper-class="customer-table-controls-select-popper"
                    :suffix-icon="Icon.ArrowDown"
                    multiple
                    :reserve-keyword="false"
                    clearable)
          aiq-option(v-for="agent in agentFilterOptions"
                    :key="agent.id"
                    :label="agent.fullName"
                    :value="String(agent.id)")
      .filter-field
        label.filter-field-label Attributes
        .attributes-toggle-group
          .attribute-toggle(v-for="option in customerAgentOptions" :key="option")
            aiq-switch(:model-value="isCustomerAgentOptionSelected(option)"
                       @change="toggleCustomerAgentOption(option, $event)")
            span.attribute-toggle-label {{ option }}
      .filter-field(v-for="periodOption in periodFilterOptions" :key="periodOption.dateType")
        label.filter-field-label {{ periodOption.label }}
        .joined-date-filter-row(v-if="periodOption.dateType === joinedDateType")
          aiq-date-picker.date-filter-picker(v-model="filters.periods[periodOption.dateType].period_start"
                          size="small"
                          type="date"
                          placeholder="Start Date"
                          aria-label="Start Date"
                          popper-class="customers__date-picker-popup"
                          :prefix-icon="dateOnlyPickerPrefixIcon"
                          :disabled-date="disabledDatePickerRange"
                          :format="periodOption.format"
                          :clearable="true"
                          :teleported="false")
          aiq-date-picker.date-filter-picker(v-model="joinedEndDate"
                          size="small"
                          type="date"
                          placeholder="End Date"
                          aria-label="End Date"
                          popper-class="customers__date-picker-popup"
                          placement="bottom-end"
                          :popper-options="{ modifiers: [{ name: 'flip', options: { fallbackPlacements: ['top-end'] } }] }"
                          :default-time="endDatePickerDefaultTime"
                          :prefix-icon="dateOnlyPickerPrefixIcon"
                          :disabled-date="disabledDatePickerRange"
                          :format="periodOption.format"
                          :clearable="true"
                          :teleported="false")
        template(v-else)
          .date-filter-row
            aiq-date-picker.date-filter-picker(v-model="filters.periods[periodOption.dateType].period_start"
                            size="small"
                            :type="periodOption.componentType"
                            placeholder="Start date/time"
                            popper-class="customers__date-picker-popup"
                            :prefix-icon="datePickerPrefixIcon"
                            :disabled-date="disabledDatePickerRange"
                            :format="periodOption.format"
                            :teleported="false")
          .date-filter-row
            aiq-date-picker.date-filter-picker(v-model="filters.periods[periodOption.dateType].period_end"
                            size="small"
                            :type="periodOption.componentType"
                            placeholder="End date/time"
                            popper-class="customers__date-picker-popup"
                            :default-time="endDatePickerDefaultTime"
                            :prefix-icon="datePickerPrefixIcon"
                            :disabled-date="disabledDatePickerRange"
                            :format="periodOption.format"
                            :teleported="false")
  .form-actions
    aiq-button(link @click.stop="clearFiltersForm") Clear all
    .form-actions-right
      aiq-button(@click.stop="closeFiltersForm()") Cancel
      aiq-button.filter-action-button(size="small"
                type="primary"
                @click.stop="applyFilter"
                :disabled="isFilterUnchanged") Apply
</template>

<script>
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import isUndefined from 'lodash/isUndefined';
import CollapsibleSelect from '@/components/CollapsibleSelect/CollapsibleSelect.vue';
import { mapState } from 'vuex';
import dayjs from '@/localPlugins/dayjs';
import { createFontAwesomeIcon } from '@/libs';
import get from 'lodash/get';

const PSEUDO_OPTION = { field: 'pseudo-field', label: 'All', selected: true };
const DATE_TIME_PICKER_ICON = createFontAwesomeIcon('calendar-clock', { name: 'CustomerDateTimePickerIcon' });
const DATE_ONLY_PICKER_ICON = createFontAwesomeIcon('calendar-days', { name: 'CustomerDateOnlyPickerIcon' });
const JOINED_DATE_TYPE = 'joined_date';
const END_DATE_PICKER_DEFAULT_TIME = new Date(2000, 0, 1, 23, 59, 59); // eslint-disable-line no-magic-numbers
const UNIX_TIMESTAMP_MAX_LENGTH = 10;
const PERIOD_FILTER_OPTIONS = [
  { label: 'Joined date', dateType: JOINED_DATE_TYPE, format: 'MM/DD/YYYY', componentType: 'date' },
  { label: 'Last interaction', dateType: 'last_chat_time', format: 'MM/DD/YYYY hh:mm A', componentType: 'datetime' },
  { label: 'Last feedback sent', dateType: 'last_feedback_sent_at', format: 'MM/DD/YYYY hh:mm A', componentType: 'datetime' },
  { label: 'Last feedback completed', dateType: 'last_feedback_completed_at', format: 'MM/DD/YYYY hh:mm A', componentType: 'datetime' },
];
const URL_FILTER_QUERY_KEYS = [
  'query',
  'customer_profile_field',
  'customer_segments',
  'customer_tags',
  'customer_channel',
  'agent_ids',
  'primary_agent_ids',
  'team_ids',
  'customer_attributes',
  'periods',
  'agent-id',
  'agent-name',
  'filter-type',
];

export default {
  name: 'CustomerTableControls',
  components: {
    CollapsibleSelect,
  },
  data() {
    return {
      showFiltersForm: false,
      filters: this.getDefaultFilters(),
      committedFilters: this.getDefaultFilters(),
      skipRouteFilterApply: false,
    };
  },
  emits: ['apply-filter'],
  props: {
    pagination: {
      type: Object,
      default: () => ({
        offset: 0,
        limit: 0,
        rowCount: 0,
      }),
    },
    customerProfileOptions: {
      type: Array,
      default: () => [],
    },
    customerAgentOptions: {
      type: Array,
      default: () => [],
    },
    customerChannelOptions: {
      type: Array,
      default: () => [],
    },
    customerSegmentOptions: {
      type: Array,
      default: () => [],
    },
    customerTagOptions: {
      type: Array,
      default: () => [],
    },
    disabledDatePickerRange: {
      type: Function,
      default: () => false,
    },
    teamFilterOptions: {
      type: Array,
      default: () => [],
    },
    agentFilterOptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      showChannelFilter: state => state.featureFlags.FEATURE_FLAGS.SHOW_CUSTOMER_CHANNEL_FILTER,
      usePermissionBasedFilters: state => state.featureFlags.FEATURE_FLAGS.PERMISSION_BASED_CUSTOMERS_VIEW,
    }),
    totalResults() {
      return this.pagination.rowCount;
    },
    visibleResults() {
      return Math.min(this.pagination.offset + this.pagination.limit, this.pagination.rowCount);
    },
    isFilterUnchanged() {
      return isEqual(this.filters, this.committedFilters);
    },
    customerProfileOptionsList() {
      return [
        PSEUDO_OPTION,
        ...this.customerProfileOptions,
      ];
    },
    periodFilterOptions() {
      return PERIOD_FILTER_OPTIONS;
    },
    joinedDateType() {
      return JOINED_DATE_TYPE;
    },
    joinedEndDate: {
      get() {
        return this.filters.periods[JOINED_DATE_TYPE].period_end;
      },
      set(value) {
        this.filters.periods[JOINED_DATE_TYPE].period_end = value
          ? dayjs(value).endOf('day').millisecond(0).toDate()
          : null;
      },
    },
    datePickerPrefixIcon() {
      return DATE_TIME_PICKER_ICON;
    },
    dateOnlyPickerPrefixIcon() {
      return DATE_ONLY_PICKER_ICON;
    },
    endDatePickerDefaultTime() {
      return END_DATE_PICKER_DEFAULT_TIME;
    },
    activeFiltersCount() {
      return this.countActiveFilters(this.committedFilters);
    },
    appliedFilterSummaries() {
      const summaries = [];
      const {
        query,
        customerProfileOption,
        customerSegmentOption,
        customerAgentOption,
        customerChannelOption,
        customerTagOption,
        customerTeamOption,
        agentFilterOption,
        primaryAgentFilterOption,
        periods,
      } = this.committedFilters;

      if (query) {
        summaries.push({
          key: 'query',
          type: 'query',
          label: `${customerProfileOption.label}: ${query}`,
        });
      }

      if (customerSegmentOption.length) {
        summaries.push({
          key: 'segments',
          type: 'customerSegmentOption',
          label: `Segments: ${customerSegmentOption.join(', ')}`,
        });
      }

      if (customerChannelOption) {
        summaries.push({
          key: `channel-${customerChannelOption}`,
          type: 'customerChannelOption',
          label: `Channel: ${customerChannelOption}`,
        });
      }

      if (customerAgentOption.length) {
        summaries.push({
          key: 'attributes',
          type: 'customerAgentOption',
          label: `Attributes: ${customerAgentOption.join(', ')}`,
        });
      }

      if (customerTeamOption.length) {
        const teams = customerTeamOption.map(option => {
          const team = this.teamFilterOptions.find(({ id }) => String(id) === String(option));
          return get(team, 'name', option);
        });
        summaries.push({
          key: 'teams',
          type: 'customerTeamOption',
          label: `Teams: ${teams.join(', ')}`,
        });
      }

      if (this.showAssignedAgentsFilter && agentFilterOption.length) {
        const agents = agentFilterOption.map(option => {
          const agent = this.agentFilterOptions.find(({ id }) => String(id) === String(option));
          return get(agent, 'fullName', option);
        });
        summaries.push({
          key: 'agents',
          type: 'agentFilterOption',
          label: `Agents: ${agents.join(', ')}`,
        });
      }

      if (this.showPrimaryAgentsFilter && primaryAgentFilterOption.length) {
        const agents = primaryAgentFilterOption.map(option => {
          const agent = this.agentFilterOptions.find(({ id }) => String(id) === String(option));
          return get(agent, 'fullName', option);
        });
        summaries.push({
          key: 'primary-agents',
          type: 'primaryAgentFilterOption',
          label: `Primary Agents: ${agents.join(', ')}`,
        });
      }

      if (this.committedFilters.dashboardAgentFilter) {
        summaries.push({
          key: `dashboard-agent-${this.committedFilters.dashboardAgentFilter.agentId}`,
          type: 'dashboardAgentFilter',
          label: `Agent: ${this.committedFilters.dashboardAgentFilter.agentName}`,
        });
      }

      if (customerTagOption.length) {
        summaries.push({
          key: 'tags',
          type: 'customerTagOption',
          label: `Tags: ${customerTagOption.join(', ')}`,
        });
      }

      this.getAppliedPeriods(periods).forEach(period => {
        const periodOption = this.getPeriodOption(period.date_type);
        summaries.push({
          key: `period-${period.date_type}`,
          type: 'period',
          value: period.date_type,
          label: `${periodOption.label}: ${this.formatPeriodSummary(period, periodOption.format)}`,
        });
      });

      return summaries;
    },
    showAssignedAgentsFilter() {
      if (this.usePermissionBasedFilters) {
        return this.canView('/customers/visibility/my_assigned');
      }
      return true;
    },
    showPrimaryAgentsFilter() {
      if (this.usePermissionBasedFilters) {
        return this.canView('/customers/visibility/my_primary');
      }
      return true;
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.applyFilterFromRoute();
      },
      deep: true,
    },
    customerProfileOptions() {
      this.applyFilterFromRoute();
    },
    customerAgentOptions() {
      this.applyFilterFromRoute();
    },
    teamFilterOptions() {
      if (this.teamFilterOptions.length) {
        this.applyFilterFromRoute();
      }
    },
    agentFilterOptions() {
      if (this.agentFilterOptions.length) {
        this.applyFilterFromRoute();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.applyFilterFromRoute();
    });
  },
  methods: {
    toQueryArray(value) {
      if (!value) {
        return [];
      }
      return Array.isArray(value) ? value : [value];
    },
    toQueryIdArray(value, options) {
      return this.toQueryArray(value).map(id => {
        const option = options.find(item => String(item.id) === String(id));
        return option ? String(option.id) : String(id);
      });
    },
    toUrlIdArray(value) {
      return value.map(id => String(id));
    },
    createDefaultPeriods() {
      return PERIOD_FILTER_OPTIONS.reduce((accumulator, { dateType }) => ({
        ...accumulator,
        [dateType]: {
          period_start: null,
          period_end: null,
        },
      }), {});
    },
    getPeriodOption(dateType) {
      return PERIOD_FILTER_OPTIONS.find(option => option.dateType === dateType);
    },
    getAppliedPeriods(periods = this.filters.periods) {
      return PERIOD_FILTER_OPTIONS
        .map(({ dateType }) => ({
          date_type: dateType,
          period_start: periods[dateType]?.period_start || null,
          period_end: periods[dateType]?.period_end || null,
        }))
        .filter(period => period.period_start || period.period_end);
    },
    getUrlPeriods(periods) {
      return this.getAppliedPeriods(periods).map(period => ({
        date_type: period.date_type,
        ...(period.period_start && { period_start: dayjs(period.period_start).unix() }),
        ...(period.period_end && { period_end: dayjs(period.period_end).unix() }),
      }));
    },
    normalizePeriodDate(value) {
      if (!value) {
        return null;
      }

      if (Number.isInteger(Number(value)) && String(value).length <= UNIX_TIMESTAMP_MAX_LENGTH) {
        return dayjs.unix(Number(value)).toISOString();
      }

      return dayjs(value).isValid() ? dayjs(value).toISOString() : null;
    },
    parsePeriodsFromRoute(value) {
      if (!value) {
        return this.createDefaultPeriods();
      }

      let periods = value;
      if (typeof value === 'string') {
        try {
          periods = JSON.parse(value);
        } catch {
          periods = [];
        }
      }

      if (!Array.isArray(periods)) {
        periods = [];
      }

      return periods.reduce((accumulator, period) => {
        if (!this.getPeriodOption(period.date_type)) {
          return accumulator;
        }

        return {
          ...accumulator,
          [period.date_type]: {
            period_start: this.normalizePeriodDate(period.period_start),
            period_end: this.normalizePeriodDate(period.period_end),
          },
        };
      }, this.createDefaultPeriods());
    },
    formatPeriodSummary(period, periodFormat) {
      const start = period.period_start ? dayjs(period.period_start).format(periodFormat) : null;
      const end = period.period_end ? dayjs(period.period_end).format(periodFormat) : null;

      if (start && end) {
        return `${start} - ${end}`;
      }
      if (start) {
        return `From ${start}`;
      }
      return `Until ${end}`;
    },
    countActiveFilters(filters) {
      return [
        filters.query,
        filters.customerAgentOption.length,
        filters.customerChannelOption,
        filters.customerSegmentOption.length,
        filters.customerTagOption.length,
        filters.customerTeamOption.length,
        this.showAssignedAgentsFilter && filters.agentFilterOption.length,
        this.showPrimaryAgentsFilter && filters.primaryAgentFilterOption.length,
        filters.dashboardAgentFilter,
        this.getAppliedPeriods(filters.periods).length,
      ].filter(Boolean).length;
    },
    getDefaultFilters() {
      return {
        query: '',
        customerProfileOption: PSEUDO_OPTION,
        customerSegmentOption: [],
        customerAgentOption: [],
        customerChannelOption: null,
        customerTagOption: [],
        customerTeamOption: [],
        agentFilterOption: [],
        primaryAgentFilterOption: [],
        dashboardAgentFilter: null,
        periods: this.createDefaultPeriods(),
      };
    },
    openFiltersForm() {
      this.filters = cloneDeep(this.committedFilters);
      this.showFiltersForm = true;
    },
    closeFiltersForm() {
      this.filters = this.getDefaultFilters();
      this.showFiltersForm = false;
    },
    applyFilter() {
      this.committedFilters = cloneDeep(this.filters);
      this.syncFilterToUrl(this.committedFilters);
      this.$emit('apply-filter', this.getAppliedFilters());
      this.closeFiltersForm();
    },
    clearFilter() {
      this.filters = this.getDefaultFilters();
      this.committedFilters = this.getDefaultFilters();
      this.syncFilterToUrl(this.committedFilters);
      this.$emit('apply-filter', this.getAppliedFilters());
    },
    clearFiltersForm() {
      this.filters = this.getDefaultFilters();
    },
    removeFilterSummary(summary) {
      const filters = cloneDeep(this.committedFilters);

      if (summary.type === 'query') {
        filters.query = '';
        filters.customerProfileOption = PSEUDO_OPTION;
      } else if (summary.type === 'period') {
        filters.periods[summary.value] = {
          period_start: null,
          period_end: null,
        };
      } else if (Array.isArray(filters[summary.type])) {
        if (isUndefined(summary.value)) {
          filters[summary.type] = [];
        } else {
          filters[summary.type] = filters[summary.type].filter(option => option !== summary.value);
        }
      } else {
        filters[summary.type] = null;
      }

      this.filters = cloneDeep(filters);
      this.committedFilters = filters;
      this.syncFilterToUrl(this.committedFilters);
      this.$emit('apply-filter', this.getAppliedFilters());
    },
    isCustomerAgentOptionSelected(option) {
      return this.filters.customerAgentOption.includes(option);
    },
    toggleCustomerAgentOption(option, isSelected) {
      this.filters.customerAgentOption = isSelected
        ? [...new Set([...this.filters.customerAgentOption, option])]
        : this.filters.customerAgentOption.filter(selectedOption => selectedOption !== option);
    },
    getAppliedFilters() {
      const customerProfileOption = this.filters.customerProfileOption?.field === PSEUDO_OPTION.field
        ? null
        : this.filters.customerProfileOption;

      return {
        searchTerm: this.filters.query,
        searchOffset: 0,
        customerAgentOption: this.filters.customerAgentOption,
        customerChannelOption: this.filters.customerChannelOption,
        customerSegmentOption: this.filters.customerSegmentOption,
        customerTagOption: this.filters.customerTagOption,
        customerTeamOption: this.toUrlIdArray(this.filters.customerTeamOption),
        agentFilterOption: this.showAssignedAgentsFilter
          ? this.toUrlIdArray(this.filters.agentFilterOption)
          : [],
        primaryAgentFilterOption: this.showPrimaryAgentsFilter
          ? this.toUrlIdArray(this.filters.primaryAgentFilterOption)
          : [],
        dashboardAgentFilter: this.filters.dashboardAgentFilter,
        customerProfileOption,
        periods: this.getAppliedPeriods(),
      };
    },
    getDashboardAgentFilterFromRoute(query) {
      if (!query['agent-id'] || !query['filter-type']) {
        return null;
      }

      return {
        agentId: query['agent-id'],
        agentName: query['agent-name'] || query['agent-id'],
        filterType: query['filter-type'],
      };
    },
    getFilterFromRoute() {
      const query = this.$route.query || {};
      const customerProfileOption = this.customerProfileOptionsList.find(
        option => option.field === query.customer_profile_field,
      ) || PSEUDO_OPTION;

      return {
        query: query.query || '',
        customerProfileOption,
        customerSegmentOption: this.toQueryArray(query.customer_segments),
        customerAgentOption: this.toQueryArray(query.customer_attributes)
          .filter(option => this.customerAgentOptions.includes(option)),
        customerChannelOption: this.showChannelFilter ? query.customer_channel || null : null,
        customerTagOption: this.toQueryArray(query.customer_tags),
        customerTeamOption: this.toQueryIdArray(query.team_ids, this.teamFilterOptions),
        agentFilterOption: this.showAssignedAgentsFilter
          ? this.toQueryIdArray(query.agent_ids, this.agentFilterOptions)
          : [],
        primaryAgentFilterOption: this.showPrimaryAgentsFilter
          ? this.toQueryIdArray(query.primary_agent_ids, this.agentFilterOptions)
          : [],
        dashboardAgentFilter: this.getDashboardAgentFilterFromRoute(query),
        periods: this.parsePeriodsFromRoute(query.periods),
      };
    },
    hasFilterQueryParams(query = this.$route.query) {
      return URL_FILTER_QUERY_KEYS.some(key => {
        const value = query[key];
        return Array.isArray(value) ? value.length : Boolean(value);
      });
    },
    getUrlQueryFromFilters(filters) {
      const urlPeriods = this.getUrlPeriods(filters.periods);
      return {
        ...(filters.query && { query: filters.query }),
        ...(filters.query && filters.customerProfileOption?.field !== PSEUDO_OPTION.field && {
          customer_profile_field: filters.customerProfileOption.field,
        }),
        ...(filters.customerSegmentOption.length && { customer_segments: filters.customerSegmentOption }),
        ...(filters.customerTagOption.length && { customer_tags: filters.customerTagOption }),
        ...(filters.customerTeamOption.length && { team_ids: this.toUrlIdArray(filters.customerTeamOption) }),
        ...(this.showAssignedAgentsFilter && filters.agentFilterOption.length && {
          agent_ids: this.toUrlIdArray(filters.agentFilterOption),
        }),
        ...(this.showPrimaryAgentsFilter && filters.primaryAgentFilterOption.length && {
          primary_agent_ids: this.toUrlIdArray(filters.primaryAgentFilterOption),
        }),
        ...(filters.dashboardAgentFilter && {
          'agent-id': filters.dashboardAgentFilter.agentId,
          'agent-name': filters.dashboardAgentFilter.agentName,
          'filter-type': filters.dashboardAgentFilter.filterType,
        }),
        ...(this.showChannelFilter && filters.customerChannelOption && {
          customer_channel: filters.customerChannelOption,
        }),
        ...(filters.customerAgentOption.length && { customer_attributes: filters.customerAgentOption }),
        ...(urlPeriods.length && { periods: JSON.stringify(urlPeriods) }),
      };
    },
    getCurrentFilterUrlQuery() {
      return URL_FILTER_QUERY_KEYS.reduce((accumulator, key) => {
        if (this.$route.query[key]) {
          accumulator[key] = this.$route.query[key];
        }
        return accumulator;
      }, {});
    },
    syncFilterToUrl(filters) {
      const filterQuery = this.getUrlQueryFromFilters(filters);
      const currentFilterQuery = this.getCurrentFilterUrlQuery();

      if (isEqual(currentFilterQuery, filterQuery)) {
        return;
      }

      const nextQuery = { ...this.$route.query };
      URL_FILTER_QUERY_KEYS.forEach(key => {
        delete nextQuery[key];
      });

      this.skipRouteFilterApply = true;
      this.$router.push({ query: { ...nextQuery, ...filterQuery } })
        .finally(() => {
          this.$nextTick(() => {
            this.skipRouteFilterApply = false;
          });
        });
    },
    applyFilterFromRoute() {
      if (this.skipRouteFilterApply) {
        return;
      }

      const routeFilters = this.hasFilterQueryParams()
        ? this.getFilterFromRoute()
        : this.getDefaultFilters();

      if (isEqual(routeFilters, this.committedFilters)) {
        return;
      }

      this.filters = cloneDeep(routeFilters);
      this.committedFilters = routeFilters;
      this.$emit('apply-filter', this.getAppliedFilters());
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style-guide-light-theme.scss';
@import '@/styles/aiq-variables.scss';
@import '@/styles/aiq-mixins.scss';

.controls {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;

  .search-filters-summary {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
    margin-left: 10px;

    .filter-summary-tag {
      margin-right: 0;
      border: none;
      border-radius: 2px;
      background-color: $aiq-theme-background-elevated;
      color: $aiq-theme-text-primary;

      :deep(.el-tag__close) {
        color: $aiq-theme-text-primary;

        &:hover {
          background-color: $aiq-theme-background-elevated;
        }
      }
    }
  }

  .clear-filters {
    flex: 0 0 auto;
    min-height: 24px;
    padding: 0;
    font-size: 12px;
    color: $aiq-bgc-header !important;
  }

  .right-controls {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex: 0 0 auto;
    gap: 5px;

    .filter-selectors-btn {
      padding: 10px;
      height: 30px;
      display: flex;
      align-items: center;
      background-color: transparent;
      border: 1px solid $aiq-theme-border-elevated;

      svg {
        margin-right: 5px;
        color: $aiq-theme-text-secondary;
      }

      .label {
        color: $aiq-theme-text-secondary;
      }

      .filters-count {
        margin-left: 5px;
        color: $aiq-bgc-header;
      }

      &:focus {
        border-color: $aiq-theme-border-surface;
        outline: none;
      }

      &:hover {
        background-color: $aiq-theme-background-surface;
        border-color: $aiq-theme-border-surface;
      }

      &:active {
        background-color: $aiq-theme-background-elevated;
        border-color: $aiq-theme-border-elevated;
      }
    }

    .totals {
      font-size: 12px;
      font-weight: 300;
      text-align: right;
      white-space: nowrap;
    }
  }
}

.filters-form {
  height: calc(100vh - 68px);
  width: 400px;
  background-color: $aiq-theme-background-page;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 68px;
  right: 0;
  z-index: 100002;

  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border: 1px solid $aiq-bgc-header;
    background-color: $aiq-bgc-header;
    color: $aiq-color-white;

    .form-header-title {
      color: $aiq-color-white;
    }

    .form-header-close {
      cursor: pointer;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .form-body {
    @include scrollable(auto);
    flex: 1 1 auto;
    min-height: 0;
    padding: 15px;
    border: 1px solid $aiq-theme-border-default;

    .form-fields {
      .filter-field + .filter-field {
        margin-top: 12px;
      }
      .filter-field {
        .filter-field-label {
          display: block;
          margin-bottom: 6px;
        }

        .search-input {
          margin-top: 5px;

          :deep(.el-input__inner) {
            height: 30px;
            border: 1px solid $aiq-theme-border-default;
          }
        }

        .date-filter-row + .date-filter-row {
          margin-top: 5px;
        }

        .joined-date-filter-row {
          display: flex;
          gap: 8px;

          :deep(.date-filter-picker) {
            flex: 1;
            width: 0;
            min-width: 0;
          }
        }

        :deep(.date-filter-picker) {
          display: flex;
          justify-content: flex-start;

          &:hover {
            box-shadow: none;
          }
        }

        .attributes-toggle-group {
          display: flex;
          flex-direction: column;
          gap: 18px;
          padding: 8px 0 0 25px;

          .attribute-toggle {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .attribute-toggle-label {
            color: $aiq-theme-text-primary;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
          }
        }
      }
    }

  }

  .form-actions {
    display: flex;
    flex: 0 0 auto;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border: 1px solid $aiq-theme-border-default;
    border-top: 0;
    background-color: $aiq-theme-background-page;

    :deep(button.el-button *) {
      font-weight: 500;
    }

    .is-link {
      color: $aiq-bgc-header;
    }

    .form-actions-right {
      display: flex;
      gap: 5px;

      .filter-action-button {
        min-width: 64px;
      }

      .el-button--primary:not(.is-disabled) {
        background-color: $aiq-bgc-header;
        border-color: $aiq-bgc-header;
      }
    }
  }
}
</style>

<style lang="scss">
.customer-table-controls-select-popper {
  z-index: 100003 !important;
}
</style>
